import React from "react";

const FleetInformation = () => {
	return (
		<div className="features-container">
		<div className="feature-item">
		  <div className="icon">👍</div>
		  <h3 className="title">We price match</h3>
		  <p className="description">We return the difference in price</p>
		</div>
  
		<div className="feature-item">
		  <div className="icon">⏰</div>
		  <h3 className="title">Free waiting time</h3>
		  <p className="description">
			We allow free waiting time of 60 minutes at airports, all other
			locations include a free 15 minutes waiting time
		  </p>
		</div>
  
		<div className="feature-item">
		  <div className="icon">💲</div>
		  <h3 className="title">No hidden costs</h3>
		  <p className="description">
			Taxes, tolls and gratuity included
		  </p>
		</div>
  
		<div className="feature-item">
		  <div className="icon">🛡️</div>
		  <h3 className="title">Safe rides</h3>
		  <p className="description">
			We are the marketplace where you always know your carrier directly.
			All carriers are thoroughly verified
		  </p>
		</div>
	  </div>
	);
};

export default FleetInformation;